<div class="wg-o2m-dialog">

  <div class="wg-o2m-dialog-header">
    <div class="wg-o2m-dialog-heading">
      <h3>{{ tps.translate(dialogData.title) }}</h3>
      @if (subtitle) {
        <p>{{ subtitle }}</p>
      }
    </div>
    <button type="button" class="wg-o2m-dialog-close" (click)="cancel()">
      <span class="material-symbols-outlined">close</span>
    </button>
  </div>

  <div class="wg-o2m-dialog-body" #sectionBody>
    <one-to-many-section
      [forwardEntities]="dialogData.forwardEntities"
      [forwardEntityName]="dialogData.forwardEntity"
      [bindingPropertyName]="dialogData.bindingPropertyName"
      [number]="dialogData.number"
      [deleteDisabled]="true"
      [hideRepeaterActionsCondition]="dialogData.hideRepeaterActionsCondition"
      [contentTemplate]="dialogData.contentTemplate"
      [actions]="dialogData.actions"
      [ngModel]="dialogData.section"
      [ngModelOptions]="{ standalone: true }"
      [parentBindingProp]="dialogData.parentBindingProp"
      [section]="dialogData.section"
      [orderEnabled]="false"
      [orderProperty]="dialogData.orderProperty">
    </one-to-many-section>
  </div>

  <div class="wg-o2m-dialog-footer">
    @if (mandatoryError) {
      <div class="wg-o2m-dialog-error">
        <span class="material-symbols-outlined">error</span>
        {{ mandatoryMessage }}
      </div>
    }
    <div class="wg-o2m-dialog-footer-spacer"></div>
    <button type="button" class="wg-o2m-dialog-btn-cancel" (click)="cancel()">
      {{ tps.translate('Cancel') }}
    </button>
    <button type="button" class="wg-o2m-dialog-btn-save" (click)="confirm()">
      {{ tps.translate('Save') }}
      <span class="material-symbols-outlined">check</span>
    </button>
  </div>

</div>
